export default __webpack_public_path__ + "assets/images/d2ef30c88d366861b62fa0566ce891b6.svg";